<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Eventos</li>
        </ol>

        <v-card>
          <div class="row filtros">
            <div class="col-md-2">
              <div class="form-group">
                <label>Campanha</label>
                <input type="text" class="form-control" placeholder="Digite a campanha" v-model="campanha">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Escolha a consulta</label>
                <select class="form-control" @change="e => tipoConsulta = e.target.value" v-model="tipoConsulta">
                  <option value="" selected disabled hidden>Escolha a consulta</option>
                  <option value="1">%like</option>
                  <option value="2">like%</option>
                  <option value="3">%like%</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de início</label>
                <date-picker
                  v-model="dataFiltro.inicio"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de inicio"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de fim</label>
                <date-picker
                  v-model="dataFiltro.fim"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de fim"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-2 btns_center">
                  <button
                  class="btn_1 medium pull-right"
                  @click="filtraCampanha"
                >Filtrar</button>
            </div>
              
          </div>
          <v-card-title>
            <h3>Eventos</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :no-data-text="textoTabela" :headers="headers" :items="leads" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props" v-if="!(props.item.deleted_at)">
              <td>{{ props.item.id}}</td>
              <td>{{ props.item.nome === null ? 'visitante' : props.item.nome}}</td>
              <td>{{ props.item.nome === null ? '-/-' : props.item.email }}</td>
              <td>{{ props.item.nome === null ? '-/-' : props.item.telefone }}</td>
              <td>{{ padronizaData(props.item.created_at) }} {{ padronizaHora(props.item.updated_at) }}</td>
              <td class="text-xs-right botoes" >
                <span 
                  class="btn_1 mb-1 button-content" 
                  @click="() => showDetalhesLead(props.item.id)"
                >
                  Detalhes
                </span>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta, padronizaDataUS } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      lang: {
        days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dec"
        ],
        pickers: [
          "prox 7 dias",
          "prox 30 dias",
          "7 dias anteriores",
          "30 dias anteriores"
        ],
        placeholder: {
          date: "Selecione a data",
          dateRange: "Selecione o intervalo"
        }
      },
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "E-Mail", value: "email"},
        { text: "Telefone", value: "telefone"},
        { text: "Data de atualização", value: "updated_at" },
        { text: "", value: "" },
      ],
      pagination: { sortBy: "updated_at", descending: true },
      leads: [],
      campanha: "",
      tipoConsulta: "",
      dataFiltro: {
        inicio: "",
        fim: "",
      },
      isLoading: false,
    };
  },
  methods: {
    filtraCampanha(e){
      var self = this;
      self.isLoading = true;
      let inicio = "";
      let fim = "";
      self.dataFiltro.inicio ? inicio = padronizaDataUS(self.dataFiltro.inicio) : inicio = 0;
      self.dataFiltro.fim ? fim = padronizaDataUS(self.dataFiltro.fim) : fim = 0;
      ajax("get", `/eventos_sites/leads/eventos/${self.campanha}/${self.tipoConsulta}/${inicio}/${fim}`)
        .then((response) => {
          self.leads = response;
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },

    showDetalhesLead(id) {
      window.open(`/adm/detalhes-eventos/${id}`);
    }
  }
};
</script>

<style>
    .select-lead {
        margin-top: 1em;
        margin-bottom: 1em;
    }
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
    @media (min-width: 1650px) {
      .botoes{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-end;
      }
    }
</style>